module.exports = __webpack_public_path__ + "img/spin-loader.d6d948d3.svg";